import { STAGES } from "./types";

export const NFTAddr = process.env.REACT_APP_SOFA_MAKER_CONTRACT as string;
// 测试网staking合约
const sofaAddrFtm = process.env.REACT_APP_SOFA_CONTRACT as string;
export const SofaAddr = sofaAddrFtm;
// 服务器地址
export const serverPath = process.env.REACT_APP_SERVER_PATH as string;

export const network = parseInt(process.env.REACT_APP_CHAIN_ID!!.toString());

/**
 * Public Dutch Auction END
Public Dutch Auction Not Started
Public Dutch Auction Minting

Allowlist Minting
Allowlist Minting END

Whitelist Minting
Whitelist Minting END

Public Sale Minting
Public Sale End
 */

export const dashBoardNameMap: Record<number, string> = {
  [STAGES.AUCTION_END]: "Public Dutch Auction END",
  [STAGES.AUCTION_NOT_START]: "Public Dutch Auction Not Started",
  [STAGES.AUCTION_RUNNING]: "Public Dutch Auction Minting",
  [STAGES.WL1_RUNNING]: "Guaranteed Whitelist Minting",
  [STAGES.WL1_END]: "Guaranteed Whitelist Minting END",
  [STAGES.WL2_RUNNING]: "Whitelist (FCFS) Minting",
  [STAGES.WL2_END]: "Whitelist (FCFS) Minting END",
  [STAGES.PUBLIC_RUNNING]: "Public Sale Minting",
  [STAGES.PUBLIC_END]: "Public Sale End",
};

/**


auction linear config =  {
  priceList: {
    '0': '36900000000000000',
    '1': '26900000000000000',
    '2': '16900000000000000'
  },
  timeList: { '0': '1699375641', '1': '1699375841', '2': '1699376041' },
  supplyList: { '0': '2555', '1': '2555', '2': '2555' }
}
set
|                      paused                      | |                       true                       |
|                    maxSupply                     | |                       5555                       |
|                   totalMinted                    | |                        1                         |
|                   totalSupply                    | |                        1                         |
|                   currentStage                   | |                       101                        |
|                   price_auction                    | |                36900000000000000                 |
|                   minted_auction                   | |                        0                         |
|                   supply_auction                   | |                       2555                       |
|                user_minted_auction                 | |                        0                         |
|                      price                       | |                11900000000000000                 |
|                  minted_public                   | |                        0                         |
|                  supply_public                   | |                       5555                       |
|                user_minted_public                | |                        0                         |
|                    auctionStart                    | |                    1699375641                    |
|                     auctionEnd                     | |                    1699376241                    |
|                   publicStart                    | |                    1699378161                    |
|                    publicEnd                     | |                    1699381161                    |
|                       now                        | |                    1699375481                    |
 */